<template>
  <a-card :bordered="false">
    <div class="card-title">{{ $route.meta.title }}</div>
    <div class="table-operator">
      <a-button v-action:add type="primary" icon="plus" @click="handleAdd">发布新消息</a-button>
      <SearchForm ref="SearchForm" @handleSubmit="handleSeachSubmit"/>
    </div>
    <s-table
        ref="table"
        rowKey="message_id"
        :loading="isLoading"
        :columns="columns"
        :data="loadData"
        :pageSize="15"
    >
      <div slot="personnel_id" slot-scope="text, item">
        <template v-if="item.receive_type==1">
          <b>{{ item.personnel.personnel_name }}（{{ item.personnel.personnel_type == 0 ? '司机' : '押运员' }}）</b>
        </template>
        <template v-else><b>所有人</b></template>
      </div>
      <div slot="message_content" slot-scope="text, item">
        {{ text.length > 20 ? text.slice(0, 20)+'...' : text}}
      </div>
      <div class="actions" slot="action" slot-scope="text, item">
        <a v-action:fix_list @click="handleFixList(item)">确认收到列表</a>
        <a v-action:edit @click="handleEdit(item)">编辑</a>
        <a v-action:delete @click="handleDelete(item)">删除</a>
      </div>
    </s-table>
    <SaveForm ref="SaveForm" @handleSubmit="handleRefresh"/>
    <FixListModel ref="FixListModel" @handleSubmit="handleRefresh"/>
  </a-card>
</template>

<script>
import * as Api from '@/api/message'
import {STable} from '@/components'
import SaveForm from './modules/SaveForm'
import SearchForm from './modules/SearchForm'
import FixListModel from './modules/FixListModel'

export default {
  name: 'Index',
  components: {
    STable,
    SaveForm,
    SearchForm,
    FixListModel
  },
  data() {
    return {
      // 查询参数
      queryParam: {},
      // 正在加载
      isLoading: false,
      // 表头
      columns: [
        // {
        //   title: '消息ID',
        //   dataIndex: 'message_id',
        //   width: 60
        // },
        {
          title: '消息标题',
          dataIndex: 'message_title',
        },
        {
          title: '消息内容',
          dataIndex: 'message_content',
          scopedSlots: {customRender: 'message_content'}
        },
        {
          title: '接收人',
          dataIndex: 'personnel_id',
          scopedSlots: {customRender: 'personnel_id'}
        },
        {
          title: '发布时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      }
    }
  },
  created() {

  },
  methods: {
    /**
     * 查看确认列表
     */
    handleFixList(item) {
      this.$refs.FixListModel.queryParam.message_id = item.message_id
      this.$refs.FixListModel.open(item)
    },
    /**
     * 新增记录
     */
    handleAdd() {
      this.$refs.SaveForm.add()
    },

    /**
     * 编辑记录
     */
    handleEdit(item) {
      this.$refs.SaveForm.edit(item)
    },

    /**
     * 删除记录
     */
    handleDelete(item) {
      const app = this
      const modal = this.$confirm({
        title: '您确定要删除该记录吗?',
        content: '删除后不可恢复',
        onOk() {
          return Api.deleted({messageId: item['message_id']})
              .then((result) => {
                app.$message.success(result.message, 1.5)
                app.handleRefresh()
              })
              .finally(result => {
                modal.destroy()
              })
        }
      })
    },

    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },

    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },

    /**
     * 检索查询
     */
    onSearch() {
      this.handleRefresh(true)
    }

  }
}
</script>
